import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-gray-200 bg-pearl py-16 sm:py-20" aria-labelledby="system-title" data-id="element-191" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-192" data-mp="36jk4at54irec">
        <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-white px-4 py-2 text-xs font-semibold text-navy" data-id="element-193" data-mp="31kyzegexfjjk">
          <AwardIcon className="h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-194" data-mp="2wrw4o4yey41s" /> The Most Complete Pharmaceutical Manufacturing & GMP Professional System
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-195" data-mp="2nulruf5y66ur">
          {productBrand} — <span className="text-aqua" data-id="element-196" data-mp="2iuhdovsiho7p">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-medium text-gray-600" data-id="element-197" data-mp="2duml8nt38qkj">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-xl border border-gray-200 bg-white p-6 text-left text-lg font-medium leading-relaxed text-navy shadow-sm" data-id="element-198" data-mp="13yg527i6953v">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-aqua" aria-hidden="true" data-id="element-199" data-mp="u23890rbyb4w" />
          A complete technical reference to understand how medicines are made under GMP: how materials move from the
          warehouse to batch release, how the quality system controls every step, how cleanrooms and contamination
          control protect the product, and how processes, equipment and data are validated and documented.
        </p>
      </div>
    </section>;
}